<template>
  <div
    v-if="!cookiesAceptted"
    class="fixed inset-x-0 bottom-0 z-50 p-4 sm:p-6"
  >
    <div
      class="mx-auto flex max-w-3xl flex-col gap-4 rounded-2xl border border-gray-200 bg-white p-4 shadow-card-hover sm:flex-row sm:items-center sm:gap-6 sm:p-5"
    >
      <div class="flex flex-1 items-start gap-3">
        <span class="text-2xl" aria-hidden="true">🍪</span>
        <p class="text-sm leading-6 text-gray-600">
          Tento web používa súbory cookie na poskytovanie služieb a analýzu
          návštevnosti. Pokračovaním vyjadrujete súhlas s ich používaním.
        </p>
      </div>
      <button
        @click="acceptCookies"
        type="button"
        class="shrink-0 rounded-xl bg-brand-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2"
      >
        Rozumiem
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";

export default defineComponent({
  setup() {
    const cookiesAceptted = ref(
      window.localStorage.getItem("cookiesAcepted") !== null
    );
    const acceptCookies = () => {
      window.localStorage.setItem("cookiesAcepted", true);
      cookiesAceptted.value = true;
    };

    return { cookiesAceptted, acceptCookies };
  },
});
</script>
